export default __webpack_public_path__ + "static/media/choice-hunting-site-1.72e32782.jpg";